import { render } from "./ScheduleForm.vue?vue&type=template&id=19bcbc3f&scoped=true&ts=true"
import script from "./ScheduleForm.vue?vue&type=script&lang=ts"
export * from "./ScheduleForm.vue?vue&type=script&lang=ts"

import "./ScheduleForm.vue?vue&type=style&index=0&id=19bcbc3f&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bcbc3f"]])

export default __exports__